// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3NHKS","hoveredTitle":"styles_hoveredTitle__2HA_V","blurb":"styles_blurb__3Im23","invisible":"styles_invisible__1plWv"};